export default class GestionnaireChangementConnexion {
  /**
   * @type {function[] | null}
   */
  callbackUtilisateurConnecte = []

  /**
   * @type {function[] | null}
   */
  callbackUtilisateurDeconnecte = []

  constructor() {
    this.callbackUtilisateurConnecte = []
    this.callbackUtilisateurDeconnecte = []
  }

  declencherCallbackUtilisateurConnecte(pseudo) {
    if (this.callbackUtilisateurConnecte.length > 0) {
      this.callbackUtilisateurConnecte.forEach((callback) => {
        callback(pseudo)
      })
    }
  }

  declencherCallbackUtilisateurDeconnecte() {
    if (this.callbackUtilisateurDeconnecte.length > 0) {
      this.callbackUtilisateurDeconnecte.forEach((callback) => {
        callback()
      })
    }
  }
}
